<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
<!--                <strong>{{ $t('components.addWarehouse') }}</strong>-->
                <strong v-if="status_form==0">{{ $t('components.addWarehouse') }}</strong>
                <strong v-else>{{ $t('buttons.editWarehouse') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"   color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="success"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="7">
                <CRow>
                  <CCol>
                    <CInput
                        :label="$t('components.warehouseName')"

                        v-model="name"
                        autocomplete="name"
                    />
                  </CCol>
                  <CCol>
                    <CSelect
                        :label="$t('mainGroup')"

                        :options="items_natures"
                        :value.sync="selected_nature"
                    />
                  </CCol>
                  <CCol>
                    <CSelect
                        :label="$t('Maintenance')"
                        :value.sync="selected_maintence"
                        :options="maintence_items"
                    />
                  </CCol>
                  <CCol>
                    <CSelect
                        :label="$t('branch')"

                        :options="branch_items"
                        :value.sync="selected_branch"
                    />
                  </CCol>
                </CRow>
              </CCol>
              <CCol col="5">
                <CRow>

                  <CCol>
                    <CRow>
                      <CCol style="-webkit-padding-end: 0">
                        <CSelect
                            :label="$t('fromRow')"
                            :value.sync="selected_first_row"
                            :options="['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']"/>
                      </CCol>
                      <CCol class="pr-0 pl-0">
                        <CSelect
                            :label="$t('column')"
                            :value.sync="selected_first_col"

                            :options="get_1_99_data()"/>
                      </CCol>
                      <CCol style="-webkit-padding-start: 0">
                        <CSelect
                            :label="$t('floor')"
                            :value.sync="selected_first_floor"

                            :options="['1','2','3','4','5','6','7','8','9']"/>
                      </CCol>


                    </CRow>
                  </CCol>

                  <CCol >
                    <CRow>
                      <CCol style="-webkit-padding-end: 0">
                        <CSelect
                            :label="$t('toRow')"
                            :value.sync="selected_last_row"

                            :options="['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']"/>
                      </CCol>
                      <CCol class="pr-0 pl-0">
                        <CSelect
                            :label="$t('column')"
                            :value.sync="selected_last_col"

                            :options="get_1_99_data()"/>
                      </CCol>
                      <CCol style="-webkit-padding-start: 0">
                        <CSelect
                            :label="$t('floor')"
                            :value.sync="selected_last_floor"

                            :options="['1','2','3','4','5','6','7','8','9']"/>
                      </CCol>


                    </CRow>
                  </CCol>
                </CRow>
              </CCol>

              <CCol  col="6">
                <CInput
                        :label="$t('address')"
                        :placeholder="$t('languageAddress')"

                    v-model="address"

                />
              </CCol>

            </CRow>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="10">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.warehouseList') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items"
                :fields="fields"
                border
                column-filter
                striped
                @row-clicked="table_row_clicked"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.placeName }}</p>

                </td>

              </template>

              <template #code="{item}">

                <td>
                  <p >{{ item.placeCode }}</p>

                </td>

              </template>


              <template #operation="{item}">
                <td>

                    <CIcon @click.native="place_users(item)" class="mr-1 text-success" name="cil-people"/>

<!--                    <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                    <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>
                </td>
              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';



export default {
  name: 'Login',
  data() {
    return {

      address:'',
      selected_first_row:'A',
      selected_first_col:'1',
      selected_first_floor:'1',
      selected_last_row:'A',
      selected_last_col:'1',
      selected_last_floor:'1',
      edit_name:'',
      name: '',
      code: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      items_natures: [],
      selected_nature: [],
      selected_nature_filter: 0,
      maintence_items: [],
      selected_maintence: 0,
      items_shelf: [],
      fields_inventory_shelf: [
        {key: 'row', label: this.$t('tables.row'),sorter:false,filter:false, _style: 'width:5%'},
        {key: 'name', label: this.$t('tables.name'), _style: 'width:20%'},

      ],
      items: [],
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false,filter:false, _style: 'width:5%'},
        {key: 'placeName', label: this.$t('tables.name'), _style: 'width:20%'},
        {key: 'placeCode', label: this.$t('tables.code'), _style: 'width:15%'},
        {key: 'natureTitle', label: this.$t('mainGroup'), _style: 'width:15%'},
        {key: 'maintenance', label: this.$t('Maintenance'), _style: 'width:15%'},
        {key: 'branchName', label: this.$t('branch'), _style: 'width:20%'},
        {key: 'operation', label: "",filter:false, _style: 'width:10%;'},
      ],
      branch_items:[],
      selected_branch:0,
      details: [],
      selected_place_name:'',
      selected_place_id:0,
      collapseDuration: 0,
      status_form: 0,
      confirm_delete_name:"confirm_places"+new Date().getTime()+"_"+this.$vnode.tag,
      table_clicks:0,
      table_clicks_timer:null,
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.get_branches();
    this.get_natures();
    // this.get_maintence();
this.get_sys();
    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        // self.specification_options = [];
        // self.favourite_options = [];
        self.maintence_items = [];
        // self.exit_type_items = [];




        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          // if (val.titleType == 6) {
          //   self.specification_options.push(obj);
          // }
          // if (val.titleType == 7) {
          //   self.favourite_options.push(obj);
          // }
          if (val.titleType == 24) {
            self.maintence_items.push(obj);
          }
          // if (val.titleType == 25) {
          //   self.exit_type_items.push(obj);
          // }
        });

        self.maintence_items = self.sort_array([],self.maintence_items,"value","label");

        // self.selected_exit_type = self.exit_type_items[0].value

        // self.selected_specification = self.specification_options[0].value
        // self.selected_favourite = self.favourite_options[0].value

        self.selected_maintence = self.maintence_items[0].value


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_1_99_data(){
      var array = [];
      for(var i =1;i<=99;i++){
        array.push(i.toString());
      }
      return array;
    },
    get_natures() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.$route.params.cat_id);


      axios.post('GetProductNatures', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_natures = self.sort_array([],content_data.data,"id",'title');
          if(self.items_natures.length>0){
            self.selected_nature = self.items_natures[0].value;

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
              .catch(function (error) {
                console.log(error);
              });

    },

    table_row_clicked(item, index) {
this.selected_place_name= item.placeName;
this.selected_place_id= item.id;
      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item);

        this.table_clicks = 0
      }

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      // if (this.code == '') {
      //   this.$root.root_validate_errors.push(this.$t('insertWarehouseCode'));
      // }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
                  self.branch_items, content_data.data,
                  'branchId','branchTitle');

          self.selected_branch = parseInt(localStorage.getItem("branchId"));

          if(self.selected_branch==0){
            self.selected_branch = self.branch_items[0].value
          }

          self.get_lists();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      }).catch(function (error) {

                console.log(error);
              });

    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.placeName;
      this.edit_name = item.placeName;
      this.code = item.placeCode;
      this.address = item.address;
      this.selected_nature= item.natureId;
      this.selected_maintence= item.maintenanceId;
      // this.description = this.items[item.row_id].description;
      // this.previewImage = this.items[item.row_id].image;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.code = '';
      // this.description = '';
      // this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/categories/' + this.items[index].id});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    place_users(item) {

      this.$router.push({path: '/dashboard/places/users/' + item.id});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    insert_data() {
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddPlace";
      } else {
        url = "EditPlace";
        formData.append('id', this.status_form)

      }
      // Id
      // PlaceName
      // PlaceCode
      // NatureId
      // NatureTitle
      // MaintenanceId
      // Maintenance
      // Address
      // FirstRow
      // FirstCol
      // FirstCat
      // LastRow
      // LastCol
      // LastCat
      // BranchId
      // BranchName
      formData.append('PlaceName', this.name);
      formData.append('NatureId', this.selected_nature);
      formData.append('MaintenanceId', this.selected_maintence);
      formData.append('Address', this.address);
      formData.append('FirstRow', this.selected_first_row);
      formData.append('FirstCol', this.selected_first_col);
      formData.append('FirstCat', this.selected_first_floor);
      formData.append('LastRow', this.selected_last_row);
      formData.append('LastCol', this.selected_last_col);
      formData.append('LastCat', this.selected_last_floor);
      formData.append('BranchId', this.selected_branch);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.address = '';
        self.selected_branch = self.branch_items[0].value;
        self.selected_maintence = self.maintence_items[0].value;
        self.selected_nature = self.items_natures[0].value;
        self.get_lists();


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePlace";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
